module.exports = __webpack_public_path__ + "static/media/pin_odontoiatria.6bad27a6.png";